import module from 'empresa/module.js'
import template from './template.html'

export default class EmpresaInformacionSatComponent {
  empresaId = undefined
  archivo = undefined
  actualizar = false
  accept = undefined
  alerta = false
  type = undefined
  data = {}
  confirmacionCertificado = false

  constructor ($q, $fileSystem, EmpresaInformacionSat) {
    this.$q = $q
    this.$fileSystem = $fileSystem
    this.EmpresaInformacionSatService = EmpresaInformacionSat
  }

  $onInit () {
    this.promise = this.$q.all([
      this.EmpresaInformacionSatService.get(this.empresaId)
        .then((response) => (this.data = response.data)),
    ])
  }

  confirmacion (data) {
    if (data.exito) {
      this.form.$setPristine()
    }
    this.actualizar = false
  }

  confirmacionCer (data) {
    if (data.guardado) {
      this.type === 'key' ? this.data.sat.certificado_key = this.archivo.name : this.data.sat.certificado_cer = this.archivo.name
    }
    this.confirmacionCertificado = false
  }

  confirmacionEliminar (data) {
    if (data.tipo === 'key') {
      this.data.sat.certificado_key = null
    } else {
      this.data.sat.certificado_cer = null
    }
  }

  seleccionarArchivo (tipo) {
    this.accept = tipo === 'key' ? 'application/pkcs8,.key' : tipo === 'cer' ? 'application/pkix-cert,application/x-x509-ca-cert' : undefined
    this.type = tipo

    this.$fileSystem.select(false, this.accept)
      .then((files) => {
        this.archivo = files[0]
        this.archivo >= this.data.maximo ? this.alerta = true : this.confirmacionCertificado = true
      })
  }


}

module.component('empresaInformacionSat', {
  controller: EmpresaInformacionSatComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/informacion/sat/component.js